import Collection from './collection';
var Types = {};
/**
| ------------------
| Primitives
| ------------------
*/

Types.boolean = function (prop) {
  return typeof prop === 'boolean';
};

Types.boolean._name_ = 'boolean';

Types.null = function (prop) {
  return prop === null;
};

Types.null._name_ = 'null';

Types.string = function (prop) {
  return typeof prop === 'string';
};

Types.string._name_ = 'string';

Types.number = function (prop) {
  return typeof prop === 'number';
};

Types.number._name_ = 'number';

Types.map = function (prop) {
  if (typeof prop !== 'object' || prop === null) return false;
  var proto = prop;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(prop) === proto;
};

Types.map._name_ = 'map';

Types.array = function (prop) {
  return Array.isArray(prop);
};

Types.array._name_ = 'array';
/**
| ------------------
| Firebase Primitives
| ------------------
*/

Types.timestamp = function (prop) {
  try {
    return prop instanceof Date || prop instanceof Collection.Timestamp;
  } catch (e) {
    return false;
  }
};

Types.timestamp._name_ = 'timestamp';

Types.geopoint = function (prop) {
  try {
    return typeof prop.long === 'number' && typeof prop.lat === 'number' || prop instanceof Collection.GeoPoint;
  } catch (e) {
    return false;
  }
};

Types.geopoint._name_ = 'geopoint';

Types.ref = function (collection) {
  var isString = typeof collection === 'string';
  var isInstance = collection instanceof Collection;

  if (!(isString || isInstance)) {
    throw Error('Types.ref take 1 argument, collection, which must be an instance of Collection or a string');
  }

  if (isInstance) {
    collection = collection.collection.id;
  }

  function ref(prop) {
    try {
      return prop.parent.id === collection && prop instanceof Collection.DocumentReference;
    } catch (e) {
      return false;
    }
  }

  ref._name_ = 'ref';
  return ref;
};

Types.ref._name_ = 'ref';
/**
| ------------------
| Custom
| ------------------
*/

Types.oneOf = function (elements) {
  if (!Types.array(elements)) {
    throw Error('Types.oneOf take 1 argument, elements, which must be an array');
  }

  function oneOf(prop) {
    return elements.includes(prop);
  }

  oneOf._name_ = 'oneOf';
  return oneOf;
};

Types.oneOf._name_ = 'oneOf';

Types.oneOfType = function (types) {
  if (!Types.array(types)) {
    throw Error('Types.oneOfType take 1 argument, types, which must be an array');
  }

  function oneOfType(prop) {
    return types.some(function (type) {
      return type(prop);
    });
  }

  oneOfType.data = types;
  oneOfType._name_ = 'oneOfType';
  return oneOfType;
};

Types.oneOfType._name_ = 'oneOfType';
/**
| ------------------
| Extensions
| ------------------
*/

Types.number.range = function (min, max) {
  if (max === void 0) {
    max = Infinity;
  }

  if (!(Types.number(min) && Types.number(max))) {
    throw Error('Types.number.range take 2 argument, min and max, which are of Types number');
  }

  function numberRange(prop) {
    return Types.number(prop) && min <= prop && prop <= max;
  }

  numberRange._name_ = 'numberRange';
  return numberRange;
};

Types.number.range._name_ = 'number.range';

Types.array.of = function (rule) {
  if (typeof rule !== 'function') {
    throw Error('Types.array.of take 1 argument, rule, which must be a function');
  }

  function arrayOf(prop) {
    return Types.array(prop) && prop.every(rule);
  }

  arrayOf.data = rule;
  arrayOf._name_ = 'arrayOf';
  return arrayOf;
};

Types.array.of._name_ = 'array.of';

Types.ref.any = function (prop) {
  return prop instanceof Collection.DocumentReference;
};

Types.ref.any._name_ = 'ref.any';

Types.map.shape = function (rules) {
  if (typeof rules !== 'object') {
    throw Error('Types.shape take 1 argument, rules, which must be an object');
  }

  function mapShape(prop) {
    if (typeof prop !== 'object') {
      return false;
    }

    var ruleKeys = Object.keys(rules);

    for (var i = 0; i < ruleKeys.length; i++) {
      var ruleKey = ruleKeys[i];

      if (!rules[ruleKey](prop[ruleKey])) {
        return false;
      }
    }

    return true;
  }

  mapShape.data = rules;
  mapShape._name_ = 'mapShape';
  return mapShape;
};

Types.map.shape._name_ = 'map.shape';

Types.timestamp.strict = function (prop) {
  try {
    return prop instanceof Collection.Timestamp;
  } catch (e) {
    return false;
  }
};

Types.timestamp.strict._name_ = 'timestamp.strict';
/**
| ------------------
| Alias
| ------------------
*/

Types.object = Types.map;
export default Types;